var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F6F3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_23593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.264 18.2893H21.5798V19.6051H8.42188V18.2893H9.73766V13.6841C9.73766 12.2882 10.2922 10.9495 11.2792 9.96244C12.2662 8.97541 13.6049 8.4209 15.0008 8.4209C16.3967 8.4209 17.7354 8.97541 18.7224 9.96244C19.7095 10.9495 20.264 12.2882 20.264 13.6841V18.2893ZM18.9482 18.2893V13.6841C18.9482 12.6371 18.5323 11.6331 17.792 10.8928C17.0518 10.1526 16.0477 9.73669 15.0008 9.73669C13.9539 9.73669 12.9499 10.1526 12.2096 10.8928C11.4693 11.6331 11.0535 12.6371 11.0535 13.6841V18.2893H18.9482ZM13.0271 20.9209H16.9745V22.2367H13.0271V20.9209Z",
    fill: "#003636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_23593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7895,
    height: 15.7895,
    fill: "white",
    transform: "translate(7.10547 7.10547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationfill);
export default __webpack_public_path__ + "static/media/notificationfill.655d2683283a295c8694f5cb07a4cecd.svg";
export { ForwardRef as ReactComponent };